import React, { useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Dropdown from '../filters/Dropdown';

const Finance = () => {
  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-2">Finance</h5>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center ">
                        <div className="col-md-8 d-flex justify-content-start align-items-center mt-2">
                          <Dropdown
                            label="Projects"
                            items={[
                              'Action',
                              'Another action',
                              'Something else here',
                            ]}
                            icon={'mdi mdi-briefcase'}
                          />
                          <Dropdown
                            label="Members"
                            items={[
                              'Action',
                              'Another action',
                              'Something else here',
                            ]}
                            icon={'mdi mdi-account-multiple'}
                          />
                          <Dropdown
                            label="Teams"
                            items={['Team A', 'Team B', 'Team C']}
                            icon={'mdi mdi-account-multiple-outline'}
                          />
                          <p className="text-muted ml-4 mt-1 d-flex justify-content-start align-items-center">
                            <i className="mdi mdi-calendar-text font-20 mr-2 text-muted u_icon"></i>{' '}
                            2011-11-28 -&gt; 2022-12-04
                          </p>
                        </div>
                        <Button
                          className="btn bg-purple pl-4 pr-4 mb-2"
                          size="sm"
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Members</th>
                          <th>Team</th>
                          <th>Leave Policy</th>
                          <th>Used</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Subeesh Kannath</td>
                          <td>
                            <span className="table-team-name">
                              Product Management
                            </span>
                          </td>
                          <td>vacation</td>
                          <td>0 days</td>
                          <td>1 days</td>
                        </tr>
                        {/* Add other rows as needed */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default Finance;
